// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__CPrua","signatureBlock":"Footer_signatureBlock__3u1yj","signature":"Footer_signature__YbXyP"};